import { API } from "./api";

const REMOTE_IMAGE_RE = /^(https?:|blob:|data:)/i;

export function getAvatarSrc(member) {
  if (!member) return "";

  const rawPath = member.avatar_path || member.avatarPath || "";
  const fileId = member.avatar_file_id || member.avatarFileId || "";

  if (rawPath && REMOTE_IMAGE_RE.test(rawPath)) {
    return rawPath;
  }

  // Legacy avatars were stored as public root-relative paths (e.g. "/photo.jpg").
  // Those should be used directly so older records still render without requiring
  // a GridFS lookup.
  if (rawPath && rawPath.startsWith("/")) {
    return rawPath;
  }

  if (member.id && fileId) {
    return `${API}/members/${member.id}/avatar?fid=${encodeURIComponent(fileId)}`;
  }

  if (member.id && rawPath) {
    return `${API}/members/${member.id}/avatar?v=${encodeURIComponent(rawPath)}`;
  }

  if (member.id && member.has_avatar) {
    return `${API}/members/${member.id}/avatar?v=${encodeURIComponent(member.id)}`;
  }

  return "";
}
